import { IconOtherEye } from '@doltech/icons/IconOtherEye';
import { IconOtherEyeInvisible } from '@doltech/icons/IconOtherEyeInvisible';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../figma/colors-v2';
import { Typography } from '../../../../figma/DesignSystemV2/Typography';

const Main = styled.div`
  .button-wrapper {
    display: grid;
    grid-template-columns: 24px max-content;
    align-items: center;
    gap: 8px;
    background: ${colorsV2.black10};
    border-radius: 12px;
    padding: 4px 8px;
    transition: all 0.3s ease;
    cursor: pointer;
    &:hover {
      background: ${colorsV2.black20};
    }
    &:active {
      transform: scale(0.96);
    }
  }

  .icon {
    color: ${colorsV2.black80};
    font-size: 24px;
    line-height: 0;
  }
  .text {
    line-height: 0;
    color: ${colorsV2.black100};
  }
`;

interface ButtonEyeShowHideProps extends React.HTMLAttributes<HTMLDivElement> {
  isHide: boolean;
}

export const ButtonEyeShowHide = ({ isHide, ...rest }: ButtonEyeShowHideProps) => {
  return (
    <Main contentEditable={false} className={cl('button-eye-show-hide', 'font-inter')} {...rest}>
      <div contentEditable={false} className="button-wrapper">
        <div contentEditable={false} className="icon">
          {isHide ? <IconOtherEyeInvisible /> : <IconOtherEye />}
        </div>
        <div contentEditable={false} className="text">
          <Typography.Text variant="medium/14">{isHide ? 'Hiện' : 'Ẩn'}</Typography.Text>
        </div>
      </div>
    </Main>
  );
};
